import React, { useEffect, useState, Fragment } from "react";
import axios from "axios";
import { useNavigate, Link } from 'react-router-dom';
import moment from "moment";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, Col } from "reactstrap";
import "./NotificationHistory.css";

const B_URL = process.env.REACT_APP_LOGINURL;

const NotificationHistory = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authData = useSelector((state) => state.authReducer.authData);
  const currentUser = authData?.userData;
  const [storeduser] = useState(JSON.parse(localStorage.getItem("user")));
  const [notifications, setNotifications] = useState([]);
  const [filter, setFilter] = useState("all");
  const [user_type] = useState(localStorage.getItem('user_type'));

  useEffect(() => {
    fetchNotifications();
  }, [filter]);

  const fetchNotifications = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'token': authData?.sessionID || storeduser['session-id']
      };
      const payload = {
        functionName: "GetNotification_History",
        postData: { user_id: currentUser?._id || storeduser['_id'], filter }
      };
      // Only admins should fetch the broadcast admin notification history.
      // Customers and doctors fetch their own user-scoped notification history.
      const url = user_type === 'admin'
        ? "NotificationModule/GetAdmin_Notification_History"
        : "NotificationModule/GetNotification_History";
      const response = await axios.post(`${B_URL}${url}`, payload, { headers });
      if (response.data.status) {
        setNotifications(response.data.data);
      } else {
        //iph todo: 47
        //console.log("Failed to fetch notifications");
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const markNotificationAsRead = async (notification) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'token': authData?.sessionID || storeduser['session-id']
      };
      await axios.put(`${B_URL}NotificationModule/MarkRead`, { _id: notification._id }, { headers });
      setNotifications((prevNotifications) =>
        prevNotifications.map((n) =>
          n._id === notification._id ? { ...n, readAt: new Date() } : n
        )
      );
      if (notification.url) {
        window.open(notification.url, "_blank");
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const getNotificationTag = (type) => {
    switch (type) {
      case "alert":
        return <span className="notification-tag alert">{t("Alert")}</span>;
      case "message":
        return <span className="notification-tag message">{t("Message")}</span>;
      case "comment":
        return <span className="notification-tag comment">{t("Comment")}</span>;
      default:
        return <span className="notification-tag default">{t("Notification")}</span>;
    }
  };

  return (
    <Fragment>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="bg-light-gray bg-animation">
            <div className="d-flex justify-content-center align-items-center">
              <Col md="12" className="mx-auto app-login-box">
                <div className="app-page-title">
                  <div className="page-title-wrapper">
                    <div className="page-title-heading fw-bold">
                      <div className="page-title-icon">
                        <i className="pe-7s-bell icon-gradient bg-tempting-azure" />
                      </div>
                      <div>
                        {t("Notification History")}
                        <div className="page-title-subheading">
                          {t("View all your notifications, mark them as read or navigate if applicable.")}.
                        </div>
                      </div>
                    </div>
                    <div className="page-title-actions">
                      <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-success btn-hover-shine me-3">
                        {t("Back")}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="notification-history-container">
                  <div className="filter-buttons">
                    <Button color="primary" onClick={() => setFilter("all")}>{t("All")}</Button>
                    <Button color="secondary" onClick={() => setFilter("read")}>{t("Read")}</Button>
                    <Button color="warning" onClick={() => setFilter("unread")}>{t("Unread")}</Button>
                  </div>
                  <div className="notification-list">
                    {notifications.map((notification) => (
                      <div
                        key={notification._id}
                        className={`notification-item ${notification.readAt ? 'read' : 'unread'}`}
                        onClick={() => !notification.readAt && markNotificationAsRead(notification)}
                      >
                        <div className="notification-content">
                          <div className="notification-icon">
                            <i className="pe-7s-bell"></i>
                          </div>
                          <div className="notification-details">
                            {getNotificationTag(notification.type)}
                            <h4 className="notification-title">{notification.message}</h4>
                            <p className="notification-time">
                              {moment(notification.createdAt).format("MMMM Do YYYY, h:mm:ss a")}
                            </p>
                            {notification.url && (
                              <Link to={notification.url} className="notification-link" target="_blank">
                                {t("Go to Details")}
                              </Link>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default NotificationHistory;
